export { default } from './Ellipse';
